module.exports = function (modules) {
  var installedModules = {};
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function (key) {
      return value[key];
    }.bind(null, key));
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "./index.js": function _indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, "Vega", function () {
      return Vega;
    });
    var external_react_ = __webpack_require__("react"),
      external_react_default = __webpack_require__.n(external_react_),
      external_react_vega_ = __webpack_require__("react-vega"),
      external_prop_types_ = __webpack_require__("prop-types"),
      external_prop_types_default = __webpack_require__.n(external_prop_types_),
      prop_types_ = __webpack_require__("@jutro/prop-types");
    var vegaPropTypes = {
        background: external_prop_types_default.a.string,
        className: external_prop_types_default.a.string,
        data: external_prop_types_default.a.string,
        enableHover: Object(prop_types_.deprecated)(external_prop_types_default.a.bool, "5.0.0", 'Please use "hover" instead'),
        hover: external_prop_types_default.a.bool,
        height: external_prop_types_default.a.number,
        width: external_prop_types_default.a.number,
        logLevel: external_prop_types_default.a.number,
        onNewView: external_prop_types_default.a.func,
        onParseError: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", 'Please use "onError" instead'),
        onError: external_prop_types_default.a.func,
        padding: external_prop_types_default.a.number,
        renderer: external_prop_types_default.a.string,
        spec: external_prop_types_default.a.object,
        style: external_prop_types_default.a.object,
        tooltip: Object(prop_types_.deprecated)(external_prop_types_default.a.func, "5.0.0", 'Please use "onTooltip" instead'),
        onTooltip: external_prop_types_default.a.func
      },
      VegaInternal = function VegaInternal(props) {
        return external_react_default.a.createElement(external_react_vega_.Vega, props);
      };
    VegaInternal.displayName = "Vega", VegaInternal.propTypes = vegaPropTypes;
    var Vega = Object(prop_types_.withTransformedProps)(VegaInternal);
    VegaInternal.__docgenInfo = {
      componentName: "Vega",
      packageName: "@jutro/visualization",
      description: "Jutro wrapper for Vega visualization component. Detailed props descriptions can be found here -\nhttps://github.com/vega/react-vega/tree/master/packages/react-vega#props, specification -\nhttps://vega.github.io/vega/docs/specification/.",
      displayName: "Vega",
      methods: [],
      actualName: "VegaInternal",
      metadataType: "element",
      props: {
        background: {
          type: {
            name: "string"
          },
          required: !1,
          description: "The background color of the entire view"
        },
        className: {
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        data: {
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        enableHover: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "@deprecated Highlight data rectangle on hover - deprecated, see https://github.com/vega/react-vega/blob/master/CHANGELOG.md#-migration-guide",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: "hover"
          }
        },
        hover: {
          type: {
            name: "bool"
          },
          required: !1,
          description: "Highlight data rectangle on hover"
        },
        height: {
          type: {
            name: "number"
          },
          required: !1,
          description: "The height in pixels of the data rectangle"
        },
        width: {
          type: {
            name: "number"
          },
          required: !1,
          description: "The width in pixels of the data rectangle"
        },
        logLevel: {
          type: {
            name: "number"
          },
          required: !1,
          description: "Sets the current log level"
        },
        onNewView: {
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        onParseError: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated ",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: "onError"
          }
        },
        onError: {
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        },
        padding: {
          type: {
            name: "number"
          },
          required: !1,
          description: "The distance in pixels between the data rectangles"
        },
        renderer: {
          type: {
            name: "string"
          },
          required: !1,
          description: ""
        },
        spec: {
          type: {
            name: "object"
          },
          required: !1,
          description: ""
        },
        style: {
          type: {
            name: "object"
          },
          required: !1,
          description: ""
        },
        tooltip: {
          type: {
            name: "func"
          },
          required: !1,
          description: "@deprecated ",
          deprecationInfo: {
            version: "5.0.0",
            mapTo: "onTooltip"
          }
        },
        onTooltip: {
          type: {
            name: "func"
          },
          required: !1,
          description: ""
        }
      }
    };
  },
  "@jutro/prop-types": function jutro_propTypes(module, exports) {
    module.exports = require("@jutro/prop-types");
  },
  "prop-types": function propTypes(module, exports) {
    module.exports = require("prop-types");
  },
  react: function react(module, exports) {
    module.exports = require("react");
  },
  "react-vega": function reactVega(module, exports) {
    module.exports = require("react-vega");
  }
});